export default "__VITE_ASSET__DMDd5cel__"